<div class="habit-detail-page">
  <header class="habit-detail-header">
    <div class="habit-detail-title-row">
      <a
        class="lm-icon-btn"
        routerLink="/today"
        [queryParams]="{ tab: 'habits' }"
        aria-label="Back to Today"
        title="Back to Today">
        <svg lucideArrowLeft class="lm-icon" aria-hidden="true"></svg>
      </a>
      <h1 class="text-title">{{ currentHabit()?.name ?? 'Habit detail' }}</h1>
      <button
        type="button"
        class="lm-icon-btn"
        (click)="navigateToNext()"
        [disabled]="!nextHabitId()"
        aria-label="Next habit"
        title="Next habit">
        <svg lucideChevronRight class="lm-icon" aria-hidden="true"></svg>
      </button>
    </div>
    <div class="habit-execute-row" *ngIf="!loading() && !loadError()">
      <div class="habit-progress">
        <strong>Daily progress</strong>
        <span>{{ currentDayHabit()?.total ?? 0 }} / {{ currentDayHabit()?.target ?? '—' }}</span>
      </div>
      <button
        type="button"
        class="habit-increment lm-btn lm-btn--go"
        (click)="incrementHabit()"
        [disabled]="incrementing()">
        {{ incrementing() ? 'Adding…' : '+1' }}
      </button>
    </div>
    <p *ngIf="incrementError()" class="lm-error-text">{{ incrementError() }}</p>
  </header>

  <section *ngIf="loading()" class="loading">Loading habit detail…</section>

  <section *ngIf="loadError()" class="lm-notice lm-notice--danger">
    {{ loadError() }}
  </section>

  <ng-container *ngIf="!loading() && !loadError()">
    <section class="habit-state-card">
      <div class="habit-state-row">
        <strong>Open tasks</strong>
        <span>{{ openTaskCount() }}</span>
      </div>
      <div class="habit-target-actions">
        <label for="habit-target-input">Daily target</label>
        <input
          id="habit-target-input"
          name="habit-target-input"
          type="number"
          min="1"
          step="1"
          [ngModel]="getTargetDraftInput()"
          (ngModelChange)="setTargetDraftInput($event)" />
        <button type="button" class="lm-btn lm-btn--primary" (click)="saveTarget()" [disabled]="targetSaving()">
          {{ targetSaving() ? 'Saving…' : 'Save target' }}
        </button>
      </div>
      <p *ngIf="targetSaveError()" class="lm-error-text">{{ targetSaveError() }}</p>
    </section>

    <section class="tasks-section">
      <h3>Tasks</h3>
      <form class="create-task-form" (ngSubmit)="createTask()">
        <input
          type="text"
          name="newTaskTitle"
          maxlength="500"
          placeholder="Add task"
          [(ngModel)]="newTaskTitle" />
        <button type="submit" class="lm-btn lm-btn--primary" [disabled]="taskCreating() || !newTaskTitle.trim()">
          {{ taskCreating() ? 'Adding…' : 'Add task' }}
        </button>
        <label>
          Repeat
          <select
            name="newTaskRecurrenceType"
            [ngModel]="newTaskRecurrenceType()"
            (ngModelChange)="setNewTaskRecurrenceType($event)">
            <option value="NONE">None</option>
            <option value="DAILY">Daily</option>
            <option value="WEEKLY">Weekly</option>
            <option value="MONTHLY">Monthly</option>
          </select>
        </label>
        <div *ngIf="newTaskRecurrenceType() === 'WEEKLY'" class="weekday-picker" role="group" aria-label="Repeat on weekdays">
          <button type="button" class="weekday-picker-button" (click)="toggleWeeklyDay(1)" [class.active]="isWeeklyDaySelected(1)" [attr.aria-pressed]="isWeeklyDaySelected(1)">Mon</button>
          <button type="button" class="weekday-picker-button" (click)="toggleWeeklyDay(2)" [class.active]="isWeeklyDaySelected(2)" [attr.aria-pressed]="isWeeklyDaySelected(2)">Tue</button>
          <button type="button" class="weekday-picker-button" (click)="toggleWeeklyDay(3)" [class.active]="isWeeklyDaySelected(3)" [attr.aria-pressed]="isWeeklyDaySelected(3)">Wed</button>
          <button type="button" class="weekday-picker-button" (click)="toggleWeeklyDay(4)" [class.active]="isWeeklyDaySelected(4)" [attr.aria-pressed]="isWeeklyDaySelected(4)">Thu</button>
          <button type="button" class="weekday-picker-button" (click)="toggleWeeklyDay(5)" [class.active]="isWeeklyDaySelected(5)" [attr.aria-pressed]="isWeeklyDaySelected(5)">Fri</button>
          <button type="button" class="weekday-picker-button" (click)="toggleWeeklyDay(6)" [class.active]="isWeeklyDaySelected(6)" [attr.aria-pressed]="isWeeklyDaySelected(6)">Sat</button>
          <button type="button" class="weekday-picker-button" (click)="toggleWeeklyDay(7)" [class.active]="isWeeklyDaySelected(7)" [attr.aria-pressed]="isWeeklyDaySelected(7)">Sun</button>
        </div>
        <div *ngIf="newTaskRecurrenceType() === 'MONTHLY'" class="weekday-picker month-day-picker" role="group" aria-label="Repeat on days of the month">
          <button
            *ngFor="let day of monthDays"
            type="button"
            class="weekday-picker-button"
            (click)="toggleMonthlyDay(day)"
            [class.active]="isMonthlyDaySelected(day)"
            [attr.aria-pressed]="isMonthlyDaySelected(day)">{{ day }}</button>
        </div>
        <p *ngIf="newTaskRecurrenceType() === 'MONTHLY'" class="month-day-hint text-body-sm">The 29th to 31st fall on the last day in shorter months.</p>
      </form>
      <p *ngIf="taskError()" class="lm-error-text">{{ taskError() }}</p>

      <ul
        class="task-list"
        cdkDropList
        cdkDropListOrientation="vertical"
        [cdkDropListDisabled]="taskReorderSubmitting()"
        (cdkDropListDropped)="onTaskDrop($event)">
        <li
          *ngFor="let task of taskRows()"
          class="task-row"
          cdkDrag
          cdkDragLockAxis="y"
          [cdkDragDisabled]="taskReorderSubmitting()"
          tabindex="0"
          [attr.aria-label]="'Reorder ' + task.title">
          <input
            type="checkbox"
            [checked]="false"
            (change)="completeTask(task)"
            [disabled]="taskCompletingIds()[task.id]"
            [attr.aria-label]="'Complete ' + task.title" />
          <button type="button" class="task-title" (click)="openTask(task.id)">
            {{ task.title }}
          </button>
          <div class="task-actions">
            <span class="lm-row__handle" cdkDragHandle aria-hidden="true">⋮⋮</span>
            <button type="button" class="lm-btn lm-btn--danger" (click)="deleteTask(task)" [disabled]="taskDeletingIds()[task.id]">Delete</button>
          </div>
        </li>
        <li *ngIf="taskRows().length === 0" class="empty">No open tasks yet.</li>
      </ul>

      <h4 class="text-overline">Completed tasks</h4>
      <ul class="task-list">
        <li *ngFor="let task of completedTasks()">
          <div class="task-row task-row--completed">
            <input
              type="checkbox"
              checked
              (change)="reopenTask(task)"
              [disabled]="taskReopeningIds()[task.id]"
              [attr.aria-label]="'Reopen ' + task.title" />
            <button type="button" class="task-title" (click)="openTask(task.id)">
              {{ task.title }}
            </button>
            <button type="button" class="lm-btn lm-btn--danger" (click)="deleteTask(task)" [disabled]="taskDeletingIds()[task.id]">Delete</button>
          </div>
        </li>
        <li *ngIf="completedTasks().length === 0" class="empty">No completed tasks.</li>
      </ul>
    </section>
  </ng-container>
</div>
